import React from "react";
import "./HomeAbout.css";

const HomeAbout = () => {
  return (
    <section className="home-about-section">
      <div className="home-about-container">
        <div className="home-about-content">
          <div className="home-about-text">
            <h2>
              About <span>Farmology</span>
            </h2>
            <p>
              At Farmology, we are committed to revolutionizing agriculture with
              cutting-edge technology and sustainable solutions. Our mission is
              to empower farmers with tools and insights to maximize their yield
              and productivity.
            </p>
            <p>
              With a deep understanding of farming challenges, we bring
              innovative, data-driven solutions to help farmers make informed
              decisions. Join us in shaping the future of smart farming!
            </p>
            <a href="/about" className="home-about-btn">
              Learn More
            </a>
          </div>
          <div className="home-about-image">
            <img src="/Images/About_Body.webp" alt="About Farmology" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
